import React, { useState, useRef, useEffect } from "react";
import CustomScroll from "react-custom-scroll";
import { CSSTransition } from "react-transition-group";
import classnames from "class-names";
import SearchIcon from "./../icons/SearchIcon";
import ReactHtmlParser from 'react-html-parser';

const NavigationSearch = () => {
  const [data, setData] = useState([]);
  const [dropdownShown, setDropdownShown] = useState(false);
  const [query, setQuery] = useState("");
  const searchRef = useRef(null);

  const handleChange = event => {
    const value = event.target.value;
    if (value.length > 2) {
      makeRequest(value);
    };
    setQuery(value);
    setDropdownShown(value.length > 2);
  };

  const makeRequest = value => {
    const axios = require('axios');
    const url = '/search'

    axios.get(url, {
      params: { value: value },
      headers: {'Accept': 'application/json'}
    })
    .then(function (response) {
      setData(response.data);
    })
    .catch(function (error) {
      console.log(error);
    })
    .then(function () {
      // always executed

    });
  };

  const hideDropdown = () => {
    setDropdownShown(false);
  };

  const handleOutsideClick = event => {
    if (searchRef && !searchRef.current.contains(event.target)) {
      hideDropdown();
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", hideDropdown);
      window.addEventListener("mousedown", handleOutsideClick);

      return () => {
        window.removeEventListener("scroll", hideDropdown);
        window.removeEventListener("mousedown", handleOutsideClick);
      };
    }
  });

  useEffect(() => {
    if (dropdownShown) {
      document
        .querySelector(".navigation-logo")
        .classList.add("navigation-logo_search-expanded");
    } else {
      document
        .querySelector(".navigation-logo")
        .classList.remove("navigation-logo_search-expanded");
    }
  }, [dropdownShown]);

  return (
    <div
      className={classnames("navigation-search", {
        "navigation-search_expanded": dropdownShown
      })}
      ref={searchRef}
    >
      <form className="navigation-search__inner" method="get" action="/search">
        <input
          name="value"
          type="text"
          className="navigation-search__input"
          placeholder="Поиск"
          autoComplete='off'
          value={query}
          onChange={handleChange}
          onFocus={() => setDropdownShown(query !== "")}
        />
        <div className="navigation-search__inner-icon">
          <SearchIcon />
        </div>
        <CSSTransition
          in={dropdownShown}
          timeout={300}
          unmountOnExit
          classNames={"navigation-search-dropdown-animation"}
        >
          <div className="navigation-search-dropdown-container">
            <CustomScroll>
              <div className="navigation-search-dropdown-container__inner">
                {data.map((section, sectionIndex) => (
                  <div
                    key={sectionIndex}
                    className="navigation-search-dropdown-container__section"
                  >
                    <div className="navigation-search-dropdown__title">
                      <span>{`${section.title} (${section.data.length})`}</span>
                      { section.data.length > 3 &&
                        <a href={`/search?value=${query}#${section.name}`}>все</a>
                      }
                    </div>
                    {section.data.slice(0, 3).map((element, elIndex) => (
                      <a
                        className="navigation-search-dropdown__link"
                        key={"s" + sectionIndex + "_" + elIndex}
                        href={element.link}
                      >
                        {ReactHtmlParser(element.title)}
                      </a>
                    ))}
                  </div>
                ))}
              </div>
            </CustomScroll>
          </div>
        </CSSTransition>
      </form>
    </div>
  );
};

export default NavigationSearch;
